

































































import { Component } from 'vue-property-decorator';
import { ProductIssueListModule } from '@/store/Products/ProductIssueListModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ListUtils from '@/lib/listUtils';
import ProductType from '@/models/Products/ProductType';
import ProductSubType from '@/models/Products/ProductSubType';
import ProductIssueState from '@/models/Products/ProductIssues/ProductIssueState';

@Component({ name: 'ProductIssueFilterDialog' })
export default class extends SaascadaVueDialog {

    dialog = false;
    filterByProductType: ProductType = null;
    filterByProductSubType: ProductSubType = null;
    filterByProductIssueState: ProductIssueState = null;

    get stateOptions() {
        return ListUtils.productIssueStateOptions();
    }

    get typeOptions() {
        return ListUtils.productTypeOptions();
    }

    get subTypeOptions() {
        if (this.filterByProductType === ProductType.Lending) {
          return ListUtils.lendingProductSubTypeOptions();
        }
        else {
          return ListUtils.depositProductSubTypeOptions();
        }
    }

    async clear() {
        // Clear local filters and product module filters
        this.filterByProductType = null;
        this.filterByProductSubType = null;
        this.filterByProductIssueState = null;
        ProductIssueListModule.clearAllFilters();
        // Close dialog first then get product issues again
        this.dialog = false;
        await ProductIssueListModule.getProductIssues(1);
    }

    async cancel() {
        // Reset local filters back to matching the value of the module filters
        this.filterByProductType = ProductIssueListModule.filterByProductType;
        this.filterByProductSubType = ProductIssueListModule.filterByProductSubType;
        this.filterByProductIssueState = ProductIssueListModule.filterByProductIssueState;
        this.dialog = false;
    }

    async save() {
        // Update the filters in the product issue module
        ProductIssueListModule.updateProductTypeFilter(this.filterByProductType);
        ProductIssueListModule.updateProductSubTypeFilter(this.filterByProductSubType);
        ProductIssueListModule.updateProductIssueStateFilter(this.filterByProductIssueState);
        // Close dialog first then get product issues again
        this.dialog = false;
        await ProductIssueListModule.getProductIssues(1);
    }

}
